import {Component, ViewChild} from "@angular/core";
import {AsiTable, AsiTableData, AsiTableRequest} from "@asi-ngtools/lib";
import {
  CorrespondantDetailsDto,
  HistoriqueCommandeMaterielDto,
  ICommandeMaterielWebServiceClient
} from "@resources/resources";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {ArianeElement, ArianeStore} from "@digicerba/common";

@Component({
  selector: 'historique-component',
  templateUrl: './historique.component.html',
  host: { 'class': 'page' }
})
export class HistoriquePageComponent {

  @ViewChild('cmHistoriqueDataTable') historiqueTable: AsiTable<HistoriqueCommandeMaterielDto>;

  historicList: Array<HistoriqueCommandeMaterielDto> = [];
  correspondantDetails: CorrespondantDetailsDto = null;


  constructor(private arianeStore: ArianeStore, private translateService: TranslateService, private activatedRoute: ActivatedRoute,
              private commandeMaterielWebService: ICommandeMaterielWebServiceClient,
              private router: Router) {
    this.initArianne();
  }

  private initArianne() {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/"
      },
      {
        libelle: "ARIANNE.HISTORIQUE_COMMANDE.historiqueCommande",
        route: "/historique"
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.historicList = this.activatedRoute.snapshot.data['historique'];
  }

  refreshTable(asiTableRequest: AsiTableRequest) {
    let asiTableData: AsiTableData<HistoriqueCommandeMaterielDto> = new AsiTableData<HistoriqueCommandeMaterielDto>();
    asiTableData.results = this.historicList;
    this.historiqueTable.updateData(asiTableData);
  }

  goToDetail(id) {
    console.log("Go to Detail");
    this.router.navigate(['cerba/historique/' + id + '']);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/historique/historique.component.ts